export default __webpack_public_path__ + "0dd9b65aeb6c9f9093f0f4e5a49c5680.svg";